<template>
  <div>
    <el-dialog title="学习权限" :visible.sync="formVisible" :close-on-click-modal="false" width="900px" v-if="formVisible">
      <el-form ref="dataForm" :rules="formRules" :model="form" label-position="right" size="small" label-width="140px">
        <jurisdiction-vue :form="form" v-if="form" />
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="formVisible = false">
          取消
        </el-button>
        <el-button type="primary" @click="doCreate()">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import jurisdictionVue from './common/jurisdiction.vue'
import courseSubjectAuthsApi from '@/api/course/courseSubjectAuths'
import courseSubjectApi from '@/api/course/courseSubject'
function initFormBean() {
  const formBean = {
    feeAmount: '',
    freeWatchNum: '',
    lookCredits: '',
    authData: [{ authType: 1 }, { authType: 2 }, { authType: 3 }]
  }
  return formBean
}

export default {
  components: { jurisdictionVue },
  data() {
    return {
      uploadUrl: process.env.VUE_APP_BASE_API + '/sys/cosUploader/upload',
      form: initFormBean(),
      formVisible: false,
      formRules: {

      },
      form: null
    }
  },
  created() {

  },
  methods: {
    /**
     * 重置表单
     */
    resetForm() {
      this.form = initFormBean()
    },
    /**
     * 打开新建表单
     */
    handleCreate(row) {
      this.resetForm()
      this.getDetails(row)
    },
    getDetails(row) {
      courseSubjectApi.fetchById(row.id).then((res) => {
        this.form = res.data;
        this.calcEditData()
        this.formVisible = true
      })
    },
    calcEditData() {
      let { courseClassificationVOList } = this.form;
      //课程分类
      let categArr = []
      courseClassificationVOList && courseClassificationVOList.forEach(itt => {
        let arr = [itt.id]
        if (itt.courseClassificationVO) {
          arr.push(itt.courseClassificationVO.id)
          if (itt.courseClassificationVO.courseClassificationVO) {
            arr.push(itt.courseClassificationVO.courseClassificationVO.id)
          }
        }
        categArr.push(arr)
      })
      this.$set(this.form, 'courseClassificationList', categArr);
      this.$set(this.form, 'authData', [{ authType: 1 }, { authType: 2 }, { authType: 3 }]);
    },
    calcParams() {
      let params = JSON.parse(JSON.stringify(this.form))
      let arr = [], authList = params.authData;
      for (let i = 0; i < authList.length; i++) {
        let customerLevelIds = authList[i].customerLevel.filter(itt => itt.isActive).map(item => item.key)
        let technicalServiceLevelIds = authList[i].technicalServiceLevel.filter(itt => itt.isActive).map(item => item.key)
        let registerRoleIds = authList[i].registerRole.filter(itt => itt.isActive).map(item => item.key)
        let insideStaffIds = authList[i].insideStaff.filter(itt => itt.isActive).map(item => item.key)
        if (customerLevelIds.length > 0) arr.push({ authType: authList[i].authType, levelSource: 1, levelIds: customerLevelIds.toString() })
        if (technicalServiceLevelIds.length > 0) arr.push({ authType: authList[i].authType, levelSource: 2, levelIds: technicalServiceLevelIds.toString() })
        if (registerRoleIds.length > 0) arr.push({ authType: authList[i].authType, levelSource: 3, levelIds: registerRoleIds.toString() })
        if (insideStaffIds.length > 0) arr.push({ authType: authList[i].authType, levelSource: 4, levelIds: insideStaffIds.toString() })
      }
      params.authData = arr
      return params
    },
    doCreate() {
      this.$refs["dataForm"].validate((valid) => {
        if (valid) {
          let params = this.calcParams()
          let studyAuth = params.authData.find(it => it.authType === 1)
          if (!studyAuth) return this.$message.error('请选择免费学习权限')
          params.authData = JSON.stringify(params.authData)
          params.courseClassificationList = params.courseClassificationList.map(subArray => subArray.at(-1));
          this.submitGoods(params)
        }
      });
    },
    submitGoods(params) {
      delete params.studyAuth
      if (params.id) {
        delete params.freeLearningAuth
        delete params.lookCreditAuth
        delete params.paidLearningAuth
        delete params.courseClassificationVOList
        delete params.courseSubjectRepairPlanList
        delete params.courseSubjectVideoList
        delete params.courseSubjectWaresList
      }
      params.collectNum = +params.collectNum || 0
      params.examDuration = +params.examDuration || 0
      params.examNum = +params.examNum || 0
      params.examOrder = +params.examOrder || 0
      params.forwardNum = +params.forwardNum || 0
      params.likeNum = +params.likeNum || 0
      params.playNum = +params.playNum || 0
      params.examRules = +params.examRules || 0
      courseSubjectApi.update(params).then((data) => {
        this.postCallback(data)
      });
    },
    postCallback(response) {
      this.$message.success('操作成功')
      this.formVisible = false;
      this.$emit('created')
    },
  }
}
</script>
<style lang="scss" scoped>
.mt {
  margin-top: 10px;
}
.dialog-footer {
  position: absolute;
  bottom: 5px;
  text-align: right;
  right: 20px;
}

::v-deep.el-tabs {
  height: 100%;
  .el-tabs__content {
    height: 100%;
    overflow-y: auto;
    padding-bottom: 15px;
  }
}
.rig-btn {
  float: right;
}
::v-deep .el-dialog__body {
  padding: 10px 0;
}

.flexs {
  display: flex;
  align-items: center;
  .el-radio {
    margin-left: 5px;
  }
}
::v-deep .stage-box {
  .el-form-item__label {
  }
}

.el-date-editor--datetimerange.el-input,
.el-date-editor--datetimerange.el-input__inner {
  width: 100%;
}

.el-form-item--small.el-form-item {
  width: 48%;
  display: inline-block;
  vertical-align: top;
}
.el-form-item--small.el-form-item.width100 {
  width: 97%;
}
::v-deep .el-select {
  width: 100%;
}

::v-deep .el-cascader {
  width: 100%;
}
::v-deep .el-checkbox {
  margin-right: 10px;
}
::v-deep .el-upload-list__item.is-success .el-upload-list__item-status-label {
  display: none;
}
</style>
